define('menu_tree.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('menu_tree', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"menu-tree\" data-type=\"menu-tree-root\" data-view=\"MenuItems.Collection\"></div>  ";
},"useData":true}, 'extensions/Code25/Caterparts_C25_Theme/24.0.0/', 'extensions/Code25/Caterparts_C25_Theme/24.0.0/', Handlebars);
});